<template>
    <section class="pb-5 responsive-pad">
        <div class="container ">
            <div>
                <FunctionalCalendar :is-date-picker="true" :date-format="'yyyy-mm-dd'" @dayClicked="clickedDate">
                </FunctionalCalendar>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-12 calend-slots mt-4">
                    <h2 class="">Available Slots</h2>
                        <section class="pb-5 responsive-pad">
                            <div class="container ">
                                <div class="row mt-4" v-if="items.length > 0">
                                    <div class="d-grid-slots mt-3 col-sm-4" v-for="(item, index) in items" :key="index">
                                        <a :href="generateAppointmentLink(item.id)" class="text-decoration-none">
                                            <div class="slots-box">
                                                <p class="fs-16">From {{ item.from }}</p>
                                                <p class="fs-16">To {{ item.to }}</p>
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <p class="mb-0">Book Appointment</p>
                                                    <img :src="'/images/publicView/Group 1000002296.svg'"
                                                        class="img-fluid">
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <p class="fs-16 mb-2 text-center" v-else>No Slots Available!!</p>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar';
import dateTimeFormat_mixin from '../../reusable-mixins/dateTimeFormat_mixin';
export default {
    components: {
        FunctionalCalendar,
    },
    mixins: [dateTimeFormat_mixin],
    props: {
        technician: {
            default: null
        },
        store: {
            default: null
        },

    },
    mounted() {
        const dateString = new Date();
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());
        const formattedDate = `${year}-${month}-${day}`;

        this.appointment(formattedDate);
    },
    data() {
        return {
            slots: {},
            calendarData: {},
            dateClicked: null,
            items: [],
            found: true,
        }
    },
    methods: {
        generateAppointmentLink(slot_id) {
            return `/appointment/book-technician?technician=${this.technician.id}&store=${this.store.store_name}&slot_id=${slot_id}`;
        },
        clickedDate(e) {
            this.dateClicked = e.date;
            this.appointment(this.dateClicked);
        },
        appointment(date) {
            const vm = this;
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0); 
            const selectedDate = new Date(date);
            selectedDate.setHours(0, 0, 0, 0);  
            const currentTimestamp = Math.floor(currentDate.getTime() / 1000);
            const selectedTimestamp = Math.floor(selectedDate.getTime() / 1000);

            if (selectedTimestamp < currentTimestamp) {
                Vue.$toast.open({
                    message: "Selected date must be greater than or equal to today's date.",
                    type: "error",
                });
                return;
            }
            axios
                .get("/appointment/single-tech-slots", { params: { id: vm.technician.id, date: date, store: vm.store.store_name } })
                .then((response) => {
                    vm.items = response.data.successData;
                })
                .catch((error) => {
                    Vue.$toast.open({
                        message: error.data.message,
                        type: "error",
                    });
                });
        },
    }

}
</script>